/**
 * Hand-authored design-system icon (not sourced from @central-icons-react).
 * Kept in the generated icons folder using the `.gen` suffix so the barrel's
 * import convention and the generator's index rebuild both pick it up.
 *
 * A rounded diamond with an exclamation mark, used for error/danger states
 * (e.g. the Stepper error marker). The diamond fills with `currentColor`; the
 * exclamation is a separate solid white path so it stays white on any theme.
 */

import { memo } from 'react'

import { cn } from '#lib/cn'

import { type IconProps, IconSize, iconSizeValues } from '../types'

export const IconErrorDiamond = memo(function IconErrorDiamond({
  size = IconSize.Medium,
  title,
  className,
  ref,
  ...props
}: IconProps) {
  return (
    <svg
      width={`${iconSizeValues[size]}px`}
      height={`${iconSizeValues[size]}px`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={!title}
      aria-label={title}
      className={cn('shrink-0', className)}
      ref={ref}
      {...props}
    >
      {title && <title>{title}</title>}
      <path
        d="M10.7628 2.42658C11.4462 1.74325 12.554 1.7432 13.2374 2.42658L21.5734 10.7615C22.2568 11.4449 22.2567 12.5537 21.5734 13.2371L13.2374 21.5731C12.5541 22.2563 11.4462 22.2561 10.7628 21.5731L2.42687 13.2371C1.74345 12.5537 1.74345 11.445 2.42687 10.7615L10.7628 2.42658Z"
        fill="currentColor"
      />
      <path
        d="M12.0001 14.4998C11.4478 14.4998 11.0001 14.9475 11.0001 15.4998C11.0002 16.052 11.4479 16.4998 12.0001 16.4998C12.5523 16.4997 13 16.052 13.0001 15.4998C13.0001 14.9476 12.5523 14.4999 12.0001 14.4998ZM12.0001 7.99983C11.5859 7.99983 11.2501 8.33561 11.2501 8.74983V12.7498C11.2502 13.164 11.586 13.4998 12.0001 13.4998C12.4142 13.4997 12.75 13.1639 12.7501 12.7498V8.74983C12.7501 8.33567 12.4142 7.99992 12.0001 7.99983Z"
        fill="white"
      />
    </svg>
  )
})
